import Vue from 'vue'
import PDFMake from 'pdfmake'

Vue.prototype.$pdfmake = PDFMake
